// handle moment units appropriately
export const YEARS_TIME_UNIT = 'years';

// user ages
export const MAX_USER_AGE = 120;
export const MIN_USER_AGE = 18;
